import { FilteredEmployees } from "./employees/filters/reducer";
import { VehicleLiveTrackService } from "./vehicle/reducer";
import { OrgBranchStateManagement } from './branch/reducer';
import { OrgShiftStateManagement } from './shift/reducer'
import { OrgNotificationStateManagement } from "./notification/reducer";

export const storeDeclaration = [
    VehicleLiveTrackService,
    FilteredEmployees,
    OrgBranchStateManagement,
    OrgShiftStateManagement,
    OrgNotificationStateManagement
]